import {injectable} from "inversify";
import {ReportTicketAggregateEntity} from "@dropDesk/domain/entities/reports/report_ticket_aggregate/report_ticket_aggregate.entity";
import {ReportEntityFilters} from "@dropDesk/presentation/components/filters/report_entity_filters";

@injectable()
export abstract class ReportTicketAggregateRepository {
  public abstract get(period: { startDate: string, endDate: string }, filters?: ReportEntityFilters): Promise<ReportTicketAggregateEntity>;

  public abstract exportHtml(period: { startDate: string, endDate: string }, filters?: ReportEntityFilters): Promise<void>;

}
